import React, { useState } from 'react';
import {
    Badge,
    Typography,
    Button,
    MailIcon,
    MegaphoneIcon,
} from '@eventbrite/marmalade';
import { gettext } from '@eventbrite/i18n';
import { getFeesBreakdownDataByTld } from './pricingAndPackagingUtils';
import styles from './FeeBreakdown.module.scss';

export const FeeBreakdown = () => {
    const { paymentAndServiceData, sendMoreEmailsData, ebAdsCTA } =
        getFeesBreakdownDataByTld();

    return (
        <div className={styles.fee_breakdown}>
            <div className={styles.no_fees_container}>
                <div className={styles.no_fees_left_section}>
                    <div className={styles.no_fees}>
                        <Badge variant="custom" className={styles.no_fees_tag}>
                            <Typography
                                variant="body-sm-bold"
                                className={styles.tag_label}
                            >
                                {gettext('No upfront fees')}
                            </Typography>
                        </Badge>
                        <Typography
                            variant="heading-md"
                            className={styles.post_free_event}
                        >
                            {gettext(
                                'Free for you, low fees for attendees on paid tickets',
                            )}
                        </Typography>
                    </div>
                    <Button
                        onClick={() => {
                            window.location.href =
                                '/signin/signup/?referrer=%2Fmanage%2Fevents%2Fcreate%2F';
                        }}
                        variant="primary"
                        size="responsive"
                    >
                        {gettext('Get started for free')}
                    </Button>
                </div>
                <div className={styles.no_fees_right_section}>
                    <Typography variant="heading-sm" className={styles.title}>
                        {gettext('Our pricing is simple')}
                    </Typography>
                    <Typography variant="body-sm" className={styles.content}>
                        {gettext('No fees for free events')}
                    </Typography>
                    <Typography variant="body-sm" className={styles.content}>
                        {paymentAndServiceData.service_fee}
                    </Typography>
                    <Typography variant="body-sm" className={styles.content}>
                        {paymentAndServiceData.payment_fee}
                    </Typography>
                    <Typography
                        variant="body-sm"
                        className={styles.description}
                    >
                        {gettext(
                            'Fees are paid by ticket buyers on paid tickets, unless you choose to cover them.',
                        )}
                    </Typography>
                    <Typography
                        variant="body-sm-bold"
                        className={styles.content_cta}
                    >
                        <a href={paymentAndServiceData.link}>
                            {gettext('Find out more about how fees work')}
                        </a>
                    </Typography>
                </div>
            </div>
            <div className={styles.optional_upgrades}>
                <div className={styles.separator}>
                    <div className={styles.line} />
                    <Typography
                        variant="display-sm"
                        className={styles.separator_text}
                    >
                        {gettext('Optional add-ons')}
                    </Typography>
                    <div className={styles.line} />
                </div>
                <div className={styles.cards_div}>
                    <div className={styles.options}>
                        <div className={styles.option_info}>
                            <div className={styles.title_section}>
                                <div className={styles.icon_div}>
                                    <MailIcon color="#5328D7" />
                                </div>
                                <Typography
                                    variant="heading-sm"
                                    className={styles.option_title}
                                >
                                    {gettext('Send more emails')}
                                </Typography>
                            </div>
                            <Typography variant="body-sm">
                                {`${gettext(
                                    'Save on marketing costs with Eventbrite Pro and send up to 10,000 emails daily.',
                                )} ${sendMoreEmailsData.starting_price}`}
                            </Typography>
                        </div>
                        <Button
                            variant="secondary"
                            size="responsive"
                            onClick={() => {
                                window.location.href =
                                    sendMoreEmailsData.learn_more_cta;
                            }}
                            className={styles.option_cta}
                        >
                            {gettext('Learn more')}
                        </Button>
                    </div>

                    {ebAdsCTA != '' && (
                        <div className={styles.options}>
                            <div className={styles.option_info}>
                                <div className={styles.title_section}>
                                    <div className={styles.icon_div}>
                                        <MegaphoneIcon color="#5328D7" />
                                    </div>
                                    <Typography
                                        variant="heading-sm"
                                        className={styles.option_title}
                                    >
                                        {gettext('Eventbrite Ads')}
                                    </Typography>
                                </div>
                                <Typography variant="body-sm">
                                    {gettext(
                                        "Increase your event's visibility with sponsored placements on top spots across Eventbrite",
                                    )}
                                </Typography>
                            </div>
                            <Button
                                variant="secondary"
                                size="responsive"
                                onClick={() => {
                                    window.location.href = ebAdsCTA;
                                }}
                                className={styles.option_cta}
                            >
                                {gettext('Learn more')}
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FeeBreakdown;
